import { useTranslation } from "react-i18next";
import logo from "../../../assets/logo.png";
import caramelizada from "../../../assets/caramelizada.png";
import cajuzinho from "../../../assets/cajuzinho.png";
import pacoca from "../../../assets/pacoca.png";

export default function Doces() {
  const { t } = useTranslation();

  return (
    <section id="receitas_doces" className="receitas section_inicial">
      <div className="imagem-texto">
        <h1>{t("receitas.doces.titulo")}</h1>
        <img src={logo} alt="Logo GranCaju" />
      </div>

      <div className="receitas-container">
        <div className="receita">
          <div>
            <h2>{t("receitas.doces.r1.titulo")}</h2>
            <p>{t("receitas.doces.r1.porcao")}</p>
            <ul>
              <li>{t("receitas.doces.r1.ingredientes.i1")}</li>
              <li>{t("receitas.doces.r1.ingredientes.i2")}</li>
              <li>{t("receitas.doces.r1.ingredientes.i3")}</li>
              <li>{t("receitas.doces.r1.ingredientes.i4")}</li>
            </ul>
            <p>{t("receitas.doces.r1.preparo")}</p>
          </div>
          <img src={caramelizada} alt="Imagem Castanha-de-Caju Caramelizada" />
        </div>

        <div className="receita inverter">
          <img src={cajuzinho} alt="Imagem Cajuzinho de Castanha-de-Caju" />
          <div>
            <h2>{t("receitas.doces.r2.titulo")}</h2>
            <p>{t("receitas.doces.r2.porcao")}</p>
            <ul>
              <li>{t("receitas.doces.r2.ingredientes.i1")}</li>
              <li>{t("receitas.doces.r2.ingredientes.i2")}</li>
              <li>{t("receitas.doces.r2.ingredientes.i3")}</li>
              <li>{t("receitas.doces.r2.ingredientes.i4")}</li>
              <li>{t("receitas.doces.r2.ingredientes.i5")}</li>
            </ul>
            <p>{t("receitas.doces.r2.preparo")}</p>
          </div>
        </div>

        <div className="receita">
          <div>
            <h2>{t("receitas.doces.r3.titulo")}</h2>
            <p>{t("receitas.doces.r3.porcao")}</p>
            <ul>
              <li>{t("receitas.doces.r3.ingredientes.i1")}</li>
              <li>{t("receitas.doces.r3.ingredientes.i2")}</li>
              <li>{t("receitas.doces.r3.ingredientes.i3")}</li>
            </ul>
            <p>{t("receitas.doces.r3.preparo")}</p>
          </div>
          <img src={pacoca} alt="Imagem Paçoca de Castanha-de-Caju" />
        </div>
      </div>
    </section>
  );
}
